<template>
  <div>
    <img
      :src="prefixURL + 'mobile/img/mp/recruit.png'"
      alt=""
      class="recruit"
    >
    <van-button
      class="dialPhoneBtn"
      text="点击拨打客服电话"
      block
      @click="dialPhone('0752-2162293')"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {
    dialPhone(phone) {
      if (this.$store.getters.ambientType != 1 || this.GetQueryString("coquettish") == 1) {
        window.location.href = 'tel:' + phone;
      } else {
        window.Android.dialPhone(phone);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.recruit {
  width: 100%;
  height: 100%;
  display: block;
}
.dialPhoneBtn {
  width: 345px;
  height: 45px;
  padding: 0;
  position: fixed;
  left: 15px;
  bottom: 48px;
  font-size: 18px;
  color: #ffffff;
  background-color: #5f93df;
  border-width: 0 !important;
  border-radius: 5px;
}
</style>